import { render, staticRenderFns } from "./facturas.view.vue?vue&type=template&id=3aa3993c"
import script from "./facturas.view.vue?vue&type=script&lang=js"
export * from "./facturas.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports